import { cnpj, cpf } from 'cpf-cnpj-validator';
import { string } from 'yup';

export const cpfCnpjSchema = string()
  .typeError('o CPF/CNPJ precisa ser um campo de texto')
  .required('Informe um CPF/CNPJ')
  .test('validate-cpf-cnpj', 'CPF/CNPJ inválido', (value) =>
    value ? cpf.isValid(value) || cnpj.isValid(value) : true,
  );
